const plPostCode = (value) => {
  const pattern = /^\d{2}-\d{3,4}$/;
  
  if (!(pattern.test(value))) {
    return ['checkout.error.formFields.postalCode', '00-000 or 00-0000'];
  }
};

export default plPostCode;
